(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mirror-store-navigation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.currentScript?.closest('.shopify-section')?.querySelector('[data-mirror-store]') || document.querySelector('[data-mirror-store]');
    const key = root?.dataset.wishlistKey || 'mirror-handmade-wishlist';
    const getItems = () => {
      try { return JSON.parse(localStorage.getItem(key)) || []; } catch (error) { return []; }
    };
    const setItems = (items) => localStorage.setItem(key, JSON.stringify(items));
    const update = () => {
      const items = getItems();
      document.querySelectorAll('[data-mirror-wishlist-count]').forEach((element) => { element.textContent = items.length ? items.length : ''; });
      document.querySelectorAll('[data-mirror-wishlist-items]').forEach((element) => {
        element.innerHTML = items.map((item) => `<a href="${item.url}">${item.title}</a>`).join('');
      });
      document.querySelectorAll('[data-mirror-wishlist-empty]').forEach((element) => { element.hidden = items.length > 0; });
      document.querySelectorAll('[data-mirror-wishlist-add]').forEach((button) => {
        button.setAttribute('aria-pressed', items.some((item) => item.url === button.dataset.productUrl) ? 'true' : 'false');
      });
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-mirror-wishlist-trigger]');
      if (trigger) { document.getElementById(trigger.getAttribute('aria-controls'))?.showModal(); }
      if (event.target.closest('[data-mirror-wishlist-close]')) { event.target.closest('dialog')?.close(); }
      const add = event.target.closest('[data-mirror-wishlist-add]');
      if (add) {
        const items = getItems();
        const url = add.dataset.productUrl;
        const exists = items.find((item) => item.url === url);
        setItems(exists ? items.filter((item) => item.url !== url) : [...items, { url, title: add.dataset.productTitle }]);
        update();
      }
    });
    update();
  })();

  } catch(e) { console.error(e); }
})();
})();
